import { render } from "./LeaderboardBuddy.vue?vue&type=template&id=0e3c3415&scoped=true"
import script from "./LeaderboardBuddy.vue?vue&type=script&lang=js"
export * from "./LeaderboardBuddy.vue?vue&type=script&lang=js"

import "./LeaderboardBuddy.vue?vue&type=style&index=0&id=0e3c3415&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3c3415"]])

export default __exports__